import { React, useState, useEffect } from "react";
import "animate.css";
import {
	Button,
	Typography,
	Container,
	Dialog,
	DialogTitle,
	DialogActions,
	DialogContent,
	DialogContentText,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

function AuthDialog({
	openStatus,
	onClose,
	message,
	title,
	name,
	email,
	createUser,
}) {
	//const theme = useTheme();
	//const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const [dialogTitle, setTitle] = useState(title);
	const [loading, setLoading] = useState(false);
	const [dialogMessage, setMessage] = useState(message);
	const [dialogCreateUser, setCreateUser] = useState(createUser);

	useEffect(() => {
		setTitle(title);
		setMessage(message);
		setCreateUser(createUser);
	}, [title, message, createUser]);

	const requestAccess = async (name, email) => {
		setLoading(true);
		const payload = {
			name,
			email,
		};
		const res = await fetch(
			"https://us-central1-mealplanner-f6b88.cloudfunctions.net/api/create-user",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(payload),
			}
		);
		const data = await res.json();
		setMessage(data.message);
		setTitle(data.title);
		setLoading(false);
		setCreateUser(false);
	};

	return (
		<Dialog
			open={openStatus}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{dialogMessage}
					{dialogCreateUser ? (
						<Container>
							<Typography>
								<b>Name:</b> {name}
							</Typography>
							<Typography>
								<b>Email:</b> {email}
							</Typography>
						</Container>
					) : (
						""
					)}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				{dialogCreateUser && (
					<LoadingButton
						loading={loading}
						loadingIndicator={"Loading..."}
						onClick={() => requestAccess(name, email)}
					>
						Request Access
					</LoadingButton>
				)}
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
}

export default AuthDialog;
